import { connect } from 'react-redux';

import SearchPagination from './component';
import { trackPaginationNumberClick } from '../../../actions';
import { getSearchParameters } from '../../../state';

const mapDispatchToProps = {
    trackPaginationNumberClick,
};

const mapStateToProps = state => ({
    parameters: getSearchParameters(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchPagination);
